(() => {
  const selector = '#cart-drawer .cart__checkout-button';

  const createDots = () => {
    const dots = document.createElement('span');
    dots.className = 'aoctant-checkout-loading__dots';
    dots.setAttribute('aria-hidden', 'true');

    dots.append(
      document.createElement('span'),
      document.createElement('span'),
      document.createElement('span')
    );

    return dots;
  };

  const ensureLoadingLayers = (button) => {
    const base = button.querySelector(
      ':scope > .aoctant-button-wave__foreground--base'
    );

    const sweep = button.querySelector(
      ':scope > .aoctant-button-wave__foreground--sweep'
    );

    if (!(base instanceof HTMLElement)) return false;
    if (!(sweep instanceof HTMLElement)) return false;

    if (!base.querySelector(':scope > .aoctant-checkout-loading__dots')) {
      base.append(createDots());
    }

    if (!sweep.querySelector(':scope > .aoctant-checkout-loading__dots')) {
      sweep.append(createDots());
    }

    return true;
  };

  document.addEventListener('click', (event) => {
    const target = event.target;

    if (!(target instanceof Element)) return;

    const button = target.closest(selector);

    if (!(button instanceof HTMLButtonElement)) return;
    if (button.disabled) return;

    const form = button.form;

    if (!(form instanceof HTMLFormElement)) return;

    if (button.dataset.aoctantCheckoutLoading === 'true') {
      event.preventDefault();
      return;
    }

    /*
      AOCTANT loading owns foreground content only.

      The finalized wave controller remains completely free to
      process mouseenter / mouseleave while checkout is loading.
    */
    event.preventDefault();

    if (!ensureLoadingLayers(button)) {
      form.requestSubmit(button);
      return;
    }

    button.dataset.aoctantCheckoutLoading = 'true';

    const checkoutLock = button.querySelector(
      ':scope > .aoctant-cart-checkout__lock'
    );

    if (checkoutLock instanceof HTMLElement) {
      checkoutLock.style.setProperty('display', 'none', 'important');
    }

    /*
      Busy semantics live on the form, not the button.
      This avoids triggering the shared button engine's
      native processing/rest ownership.
    */
    form.setAttribute('aria-busy', 'true');

    requestAnimationFrame(() => {
      setTimeout(() => {
        form.requestSubmit(button);
      }, 0);
    });
  });

  window.addEventListener('pageshow', () => {
    const button = document.querySelector(selector);

    if (!(button instanceof HTMLButtonElement)) return;

    button.removeAttribute('data-aoctant-checkout-loading');
    button.form?.removeAttribute('aria-busy');

    const checkoutLock = button.querySelector(
      ':scope > .aoctant-cart-checkout__lock'
    );

    if (checkoutLock instanceof HTMLElement) {
      checkoutLock.style.removeProperty('display');
    }
  });
})();